import Component from "./ButtonCell";
import BottomAddon from "./components/BottomAddon/ButtonCellBottomAddon";
import Label from "./components/Label/ButtonCellLabel";
import LeftAddon from "./components/LeftAddon/ButtonCellLeftAddon";
import RightAddon from "./components/RightAddon/ButtonCellRightAddon";
import Subtitle from "./components/Subtitle/ButtonCellSubtitle";
import Value from "./components/Value/ButtonCellValue";

export interface IButtonCellExtensions {
    Label: typeof Label;
    Subtitle: typeof Subtitle;
    Value: typeof Value;
    LeftAddon: typeof LeftAddon;
    RightAddon: typeof RightAddon;
    BottomAddon: typeof BottomAddon;
}

export const ButtonCell: typeof Component & IButtonCellExtensions =
    Object.assign(Component, {
        Label,
        Subtitle,
        Value,
        LeftAddon,
        RightAddon,
        BottomAddon,
    });

export type { ButtonCellProps } from "./types";
